export class SuppliesModel{
  supCode = '';
  supName = '';
  supAddress = '';
  supNotes ='';
  supGroup = '';
  compCode = '1';
  userID = '';
  modifaiedDate = '2021-01-01';
}
